const map = document.querySelector('.section-locations__map');
const mapCircles = map.querySelectorAll('circle');
const modal = document.querySelector('.section-locations .modal');
const modalContent = modal?.querySelector('.modal__content');
let mapLocations;

const createModal = (targetLocation) => {
    const locationId = targetLocation.getAttribute('id')?.toLowerCase().replace(/\s/g, '_');
    const acriveCircle = map.querySelector('circle.active');

    if(targetLocation !== acriveCircle) {
        acriveCircle?.classList.remove('active');
        targetLocation?.classList.add('active');
        const activeLocation = mapLocations?.find((location) => location.title.toLowerCase().replace(/\s/g, '_') === locationId);
        let contentData = activeLocation && activeLocation?.title ? `<h3 class="modal__title">${activeLocation.title}</h3>` : '';
        contentData +=  activeLocation && activeLocation?.subtitle ? `<h4 class="modal__subtitle">${activeLocation.subtitle}</h4>` : '';
        contentData += (activeLocation && activeLocation?.image) ? `<img class="modal__image" src="${activeLocation.image.url}" alt="${activeLocation.image.alt ? activeLocation.image.alt : activeLocation.title}" width="${activeLocation.image.width}" height="${activeLocation.image.height}" />` : '';
        contentData +=  activeLocation && activeLocation?.postcode ? `<p class="modal__postcode"><span>Postcode:</span> ${activeLocation.postcode}</p>` : '';
        contentData +=  activeLocation && activeLocation?.dispensers ? `<p class="modal__dispensers"><span>Number of dispensers:</span> ${activeLocation.dispensers}</p>` : '';
        contentData +=  activeLocation && (activeLocation?.google_map_link || activeLocation?.what3words_link) && `<div class="modal__buttons">`;
        contentData +=  activeLocation && activeLocation?.google_map_link ? `<a href="${activeLocation.google_map_link.url}" target="${activeLocation.google_map_link.target}" class="modal__link sk-btn sk-btn--third">${activeLocation.google_map_link.title}</a>` : '';
        contentData +=  activeLocation && activeLocation?.what3words_link ? `<a href="${activeLocation.what3words_link.url}" target="${activeLocation.what3words_link.target}" class="modal__link sk-btn sk-btn--third">${activeLocation.what3words_link.title}</a>` : '';
        contentData +=  activeLocation && (activeLocation?.google_map_link || activeLocation?.what3words_link) && `</div>`;
        if (contentData) modalContent.innerHTML = contentData;
        contentData && !modal?.classList.contains('open') && modal.classList.add('open');
    }
}

const hidePopup = () => {
    modal.classList.remove('open');
    map.querySelector('circle.active')?.classList.remove('active');
    modal.addEventListener('transitionend', () => {
        if(!modal.classList.contains('open')) modalContent.innerHTML = '';
    });
}

const fetchFieldsToModal = () => {
    fetch(`${themeVars.home}/wp-json/wp/v2/pages/${themeVars.pageID}?acf_format=standard`, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
    .then(async response => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return response.json();
    })
    .then(data => {
        const layouts = data['acf']['layouts'];
        if(layouts.length > 0) {
            const activeLayout = layouts.find((layout) => layout['acf_fc_layout'] === 'locations');
            mapLocations = activeLayout['locations']['map_locations'];
        }
    })
    .catch((error) => console.log(error))
    .finally(() => {});
}

const openModal = () => {
    if(!map) return;
    fetchFieldsToModal();

    const modalClose = modal?.querySelector('.close');

    map.addEventListener('click', (e) => {
        const targetLocation = e.target.closest("circle");
        targetLocation && createModal(targetLocation);
    });

    modalClose.addEventListener('click', () => hidePopup());
    document.addEventListener("keyup", (e) => (e.key === 'Escape' && modal?.classList.contains('open')) && hidePopup());
    
    mapCircles.length > 0 && mapCircles.forEach(item => {
        item.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.keyCode === 13) createModal(item);
        });
    })
    
}

const lastItemInFirstColumn = () => {
    const listItems = Array.from(document.querySelectorAll('.section-locations__item'));

    if (listItems.length === 0) return;

    const firstColumnLeft = listItems[0].offsetLeft;
    const firstColumnItems = listItems.filter(li => li.offsetLeft === firstColumnLeft);
    const lastInFirstColumn = firstColumnItems[firstColumnItems.length - 1];

    lastInFirstColumn && lastInFirstColumn?.classList.add('last-in-first-column');
}

window.addEventListener('load', () => {
    lastItemInFirstColumn();
    openModal()
});
